import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { AiAgentAvatar } from "../../../AiAgentAvatar";

export interface HistoryDetailViewSendDMProps {
  body: {
    community_bot_profile_id: number;
  };
  log: {
    message: {
      response_details: {
        body: {
          message: string;
          chat_id: number;
          chat_url: string;
        };
      };
    };
  };
}

export const HistoryDetailViewSendDM = ({
  body,
  log,
}: HistoryDetailViewSendDMProps) => {
  const { community_bot_profile_id: communityBotProfileId } = body;

  return (
    <div className="flex flex-col gap-2">
      <div className="md:flex">
        <div className="w-1/4">
          <Typography.LabelSm weight="semibold">
            {t("settings.workflows.action_messages.ai_agents.ai_agent")}
          </Typography.LabelSm>
        </div>
        <div className="w-3/4">
          <AiAgentAvatar communityBotProfileId={communityBotProfileId} />
        </div>
      </div>
      <div className="md:flex">
        <div className="w-1/4">
          <Typography.LabelSm weight="semibold">
            {t("settings.workflows.action_messages.ai_agents.chat")}
          </Typography.LabelSm>
        </div>
        <div className="w-3/4">
          {/* eslint-disable-next-line sonarjs/jsx-no-leaked-render -- Disabled for plugin version update. Fix when possible */}
          {log.message.response_details?.body?.chat_id && (
            <a
              href={log.message.response_details?.body?.chat_url}
              target="_blank"
              className="text-sm"
              rel="noopener noreferrer"
            >
              {t("settings.workflows.action_messages.ai_agents.chat_link")}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
